const ACCOUNT_TYPE_ADMIN = "admin";
const ACCOUNT_TYPE_USER = "user";
const HOME_PATH = "/dashboard";

const getAccountType = (user) => {
	if (!user) return null;
	if (user.accountType === ACCOUNT_TYPE_ADMIN || user.accountType === ACCOUNT_TYPE_USER) {
		return user.accountType;
	}
	if (user.staff === false) return ACCOUNT_TYPE_ADMIN;
	if (user.staff === true) return ACCOUNT_TYPE_USER;
	const stored = localStorage.getItem("accountType");
	if (stored === ACCOUNT_TYPE_ADMIN || stored === ACCOUNT_TYPE_USER) return stored;
	return null;
};

const getHomePath = () => HOME_PATH;

const isSuperAdmin = (user) => getAccountType(user) === ACCOUNT_TYPE_ADMIN;

export { ACCOUNT_TYPE_ADMIN, ACCOUNT_TYPE_USER, getAccountType, getHomePath, isSuperAdmin };
